import styled from 'styled-components';

export const Container = styled.div`
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(100, 109, 130, 0.14), 0 0 1px 0 rgba(100, 109, 130, 0.1);
  display: flex;
  flex-direction: column;
  padding-bottom: 4px;
`;

export const Header = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  height: 68px;
  padding: 0 24px;
  position: relative;
`;

export const Title = styled.h1`
  color: #4a4a4a;
  font-size: 16px;
  font-weight: normal;
  margin: 0;
`;

export const Image = styled.img`
  height: 249px;
  margin-bottom: 24px;
  object-fit: cover;
  width: 100%;
`;

export const LineContainer = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 21px 91px 1fr;
  margin-left: 24px;
  margin-bottom: 20px;
`;

export const LineTitle = styled.p`
  color: #a4a4a4;
  font-size: 14px;
  font-weight: normal;
  margin: 0;
`;

export const LineValue = styled.p`
  color: #555555;
  font-size: 14px;
  font-weight: normal;
  margin: 0;
`;
